module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VGSEAFOOD2-3bc25c88c70c9c48fe28feb049c872dd.png";